module.exports = __webpack_public_path__ + "static/media/home.505ece2f.svg";